import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FrontFooter.css';

const FrontFooter = () => {
  const navigate = useNavigate();

  const socialLinks = [
    { name: 'Instagram', url: 'https://www.instagram.com/seazex.official/', icon: 'fab fa-instagram' },
    { name: 'X (Twitter)', url: 'https://x.com/seazex_official', icon: 'fab fa-twitter' },
    { name: 'LinkedIn', url: 'https://www.linkedin.com/company/112959121/', icon: 'fab fa-linkedin-in' },
    { name: 'Facebook', url: 'https://web.facebook.com/profile.php?id=61572357009550', icon: 'fab fa-facebook-f' },
    { name: 'YouTube', url: 'https://www.youtube.com/@Seazex-GlobalMaritimeNetwork', icon: 'fab fa-youtube' }
  ];

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="front-footer">
      <div className="front-footer-container">
        <div className="front-footer-grid">
          <div className="front-footer-col">
            <div className="front-footer-logo" onClick={() => handleNavigate('/')}>
              Sea<span>Zex</span>
            </div>
            <p>The secure maritime service marketplace connecting ship owners with verified providers worldwide. Trusted by 500+ vessels across 100+ countries.</p>
            <div className="front-social-links">
              {socialLinks.map((social, idx) => (
                <a key={idx} href={social.url} target="_blank" rel="noopener noreferrer" className="social-link" aria-label={social.name}>
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="front-footer-col">
            <h4>Platform</h4>
            <ul>
              <li><button onClick={() => handleNavigate('/ship-owners')} className="footer-link-btn">For Ship Owners</button></li>
              <li><button onClick={() => handleNavigate('/service-providers')} className="footer-link-btn">For Service Providers</button></li>
              <li><button onClick={() => handleNavigate('/how-it-works')} className="footer-link-btn">How it Works</button></li>
              <li><button onClick={() => handleNavigate('/services')} className="footer-link-btn">Services</button></li>
              <li><button onClick={() => handleNavigate('/fleet')} className="footer-link-btn">Fleet</button></li>
            </ul>
          </div>

          <div className="front-footer-col">
            <h4>Services</h4>
            <ul>
              <li><button onClick={() => handleNavigate('/services')} className="footer-link-btn">GMDSS Services</button></li>
              <li><button onClick={() => handleNavigate('/services')} className="footer-link-btn">Navigation Systems</button></li>
              <li><button onClick={() => handleNavigate('/services')} className="footer-link-btn">Technical Spares</button></li>
              <li><button onClick={() => handleNavigate('/services')} className="footer-link-btn">Radio Surveys</button></li>
              <li><button onClick={() => handleNavigate('/services')} className="footer-link-btn">Satellite Comms</button></li>
            </ul>
          </div>

          <div className="front-footer-col">
            <h4>Support</h4>
            <ul>
              <li><button onClick={() => handleNavigate('/help-center')} className="footer-link-btn">Help Center</button></li>
              <li><a href="mailto:info@seazex.com" className="footer-link-btn">Contact Us</a></li>
              <li><button onClick={() => handleNavigate('/privacy-policy')} className="footer-link-btn">Privacy Policy</button></li>
              <li><button onClick={() => handleNavigate('/terms-of-service')} className="footer-link-btn">Terms of Service</button></li>
              <li><button onClick={() => handleNavigate('/security')} className="footer-link-btn">Security</button></li>
            </ul>
          </div>
        </div>

        <div className="front-footer-bottom">
          <p>&copy; {new Date().getFullYear()} SeaZex. All rights reserved. The Secure Maritime Service Marketplace</p>
          <div className="front-footer-badges">
            <span><i className="fas fa-shield-alt"></i> Secure Escrow</span>
            <span><i className="fas fa-check-circle"></i> Verified</span>
            <span><i className="fas fa-globe"></i> Global Coverage</span>
          </div>
          <div className="front-developed-by">
            Developed by <a href="https://vocadev.com" target="_blank" rel="noopener noreferrer">Vocadev</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;